/**
 * Fondo fijo de la web: los anillos del símbolo de Owtli a escala gigante. WebPage los gira con el scroll (cada uno en un
 * sentido) y los hace encajar con la aguja al final de la página; el tono cambia con la sección (data-tono).
 */
export default function Orbitas() {
  return (
    <div className="w-orbitas" aria-hidden="true">
      <svg viewBox="-600 -600 1200 1200">
        <defs>
          <mask id="w-corte-orbita" maskUnits="userSpaceOnUse" x="-600" y="-600" width="1200" height="1200">
            <rect x="-600" y="-600" width="1200" height="1200" fill="#fff" />
            <rect x="-14" y="-700" width="28" height="1400" fill="#000" transform="rotate(33.4)" />
          </mask>
        </defs>
        <circle className="w-anillo w-f" r="560" />
        <g className="w-g-e">
          <circle className="w-anillo w-e" r="455" />
          <circle className="w-paquete" cx="455" cy="0" r="3.5" />
          <circle className="w-paquete" cx="-322" cy="322" r="2.5" />
          <circle className="w-paquete" cx="-120" cy="-439" r="3" />
        </g>
        <g className="w-g-o">
          <circle className="w-anillo w-o" r="338" mask="url(#w-corte-orbita)" />
        </g>
        <g className="w-g-i">
          <circle className="w-anillo w-i" r="167" mask="url(#w-corte-orbita)" />
        </g>
        <g transform="rotate(33.4)">
          <path className="w-aguja" d="M0-612 6-90H-6ZM0 612 6 90H-6Z" />
        </g>
        <circle className="w-punto" r="9" />
      </svg>
    </div>
  )
}
